// subscription-flag `Reason` codes → what the RM sees (guide S0 table +
// UX copy). Only the two EXPIRED_* reasons open the blocking popup.
// OK_ON_REWARD_POINTS (a past month unpaid, but reward points are left so
// the service still runs) gets a banner on the billing page. There is no
// Hold any more — IsOnHold / HoldFrom / HoldTo are always false / null.
// EXEMPT = the employee is on the admin's "Free User Access" list: no
// AutoPay, no subscription fee, no invoice — those screens are hidden
// (FreeUserGate, Sidebar, Header).
import { formatINR, isTruthyFlag } from "../subscriptionFormat";

export const FLAG_REASON = {
  OK: "OK",
  EXEMPT: "EXEMPT",
  OK_ON_REWARD_POINTS: "OK_ON_REWARD_POINTS",
  DEBIT_FAILED: "EXPIRED_AUTOPAY_DEBIT_FAILED",
  AUTOPAY_OFF: "EXPIRED_AUTOPAY_OFF",
  NOT_APPLICABLE: "NOT_APPLICABLE",
  NOT_EMPLOYEE: "NOT_EMPLOYEE",
  CHECK_FAILED: "CHECK_FAILED",
};

export const getExpiredPopupCopy = (flag) => {
  const due = formatINR(flag?.OutstandingAmount);

  if (flag?.Reason === FLAG_REASON.DEBIT_FAILED) {
    return {
      title: "AutoPay debit failed",
      text: `Your AutoPay debit failed. Keep money in your bank account or pay now. Due: ${due}`,
      showSetAutoPay: false,
    };
  }

  return {
    title: "Subscription payment pending",
    text: `AutoPay is not active. Set up AutoPay or pay now. Due: ${due}`,
    showSetAutoPay: true,
  };
};

// "Free User Access" (Reason EXEMPT): AutoPay / Subscription / Invoice hidden.
export const isFreeUser = (flag) =>
  Boolean(flag) && (isTruthyFlag(flag.IsExempt) || flag.Reason === FLAG_REASON.EXEMPT);

export const FREE_USER_TEXT = "Free users have no AutoPay, subscription fee or invoice.";

// Menu links / routes that don't apply to a free user.
export const FREE_USER_HIDDEN_PATHS = ["/subscription-billing", "/autopay-mandate"];

// Chip shown in the subscription header — a short label + colour tone.
export const getFlagChip = (flag) => {
  if (!flag) return { label: "Status unavailable", tone: "neutral" };
  if (flag.SubscriptionExpired) return { label: "Payment pending", tone: "danger" };

  switch (flag.Reason) {
    case FLAG_REASON.EXEMPT:
      return { label: "Free user", tone: "info" };
    case FLAG_REASON.OK_ON_REWARD_POINTS:
      return { label: "Running on reward points", tone: "warning" };
    case FLAG_REASON.NOT_APPLICABLE:
    case FLAG_REASON.NOT_EMPLOYEE:
      return { label: "Not a subscriber", tone: "neutral" };
    default:
      return { label: flag.AutopayOn ? "Active · AutoPay on" : "Active", tone: "success" };
  }
};
